export default __webpack_public_path__ + "static/media/fridge1-after1-2048w.9532e883.webp";